export default __webpack_public_path__ + "static/media/22.dd0de3ce.png";